var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-4"},[_c('Links',{staticClass:"flex items-center justify-center bottom-block",staticStyle:{"box-shadow":"0px 4px 15px rgba(0, 0, 0, 0.2)"},attrs:{"category":_vm.category},scopedSlots:_vm._u([{key:"link",fn:function(ref){
var link = ref.link;
var icon = ref.icon;
var text = ref.text;
var isSelected = ref.isSelected;
return _c('a',{staticClass:"bottom-block__link",class:[{ 'bottom-block__link--selected': isSelected(_vm.$route.path)}],attrs:{"href":link}},[_c(icon,{tag:"component"}),_vm._v(" "),_c('div',{staticClass:"link__text"},[_vm._v("\n        "+_vm._s(text)+"\n      ")])],1)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }